import * as Filters from "@app/analytics/meetops/filters";
import { User } from "@app/common/types";

import { QueryDimension } from "./dimensions";
import { TrendMeta } from "./metrics";
import { Filter, PeopleOption } from "./types";

export const getBaseQuery = (people: PeopleOption, userId: User["id"]) => {
  let queryDimensions: QueryDimension[] = [];
  const queryFilters: Filter[] = [];

  if (people === "only_me") {
    queryDimensions = ["participantId"];
    queryFilters.push(Filters.isUser(userId));
  } else if (people === "everyone_but_me") {
    queryFilters.push(Filters.isNotUser(userId));
  }

  return { queryDimensions, queryFilters };
};

export const getTrendMeaning = (
  trendValue: number | null | undefined,
  trendMeta: TrendMeta
) => {
  if (trendValue == null) return undefined;

  if (trendMeta === TrendMeta.UP_POSITIVE && trendValue > 0) {
    return "good";
  }

  if (trendMeta === TrendMeta.UP_NEGATIVE && trendValue < 0) {
    return "good";
  }

  if (trendValue === 0) {
    return "neutral";
  }

  return "bad";
};
